import { create } from 'zustand';

export type GeneratorStep = 'theme' | 'config' | 'style' | 'generating' | 'done';
export type ArtStyle = '童话' | '水彩' | '科幻' | '油画' | '3D' | '剪纸' | '素描';
export type QualityTier = 'fast' | 'balanced' | 'pro';

export interface GenerationParams {
  theme: string;
  pages: number;
  ageGroup: string;
  language: string;
  style: ArtStyle;
  tier: QualityTier;
  styleReference?: string; // base64 DataURL
}

export interface GenerationStatus {
  sessionId: string;
  status: 'generating' | 'completed' | 'failed';
  currentPage: number;
  totalPages: number;
  percentage: number;
  message: string;
  pages: Array<{
    page_number: number;
    title: string;
    content: string;
    image_path?: string;
  }>;
  error?: string;
}

interface GeneratorState {
  step: GeneratorStep;
  params: GenerationParams;
  status: GenerationStatus | null;
  error: string | null;
  isSubmitting: boolean;
  pollRetries: number;
  cancelled: boolean;
  publishing: boolean;
  publishedSlug: string | null;

  setStep: (step: GeneratorStep) => void;
  setParams: (params: Partial<GenerationParams>) => void;
  setStatus: (status: GenerationStatus | null) => void;
  setError: (error: string | null) => void;
  setSubmitting: (v: boolean) => void;
  setPollRetries: (n: number) => void;
  setCancelled: (v: boolean) => void;
  setPublishing: (v: boolean) => void;
  setPublishedSlug: (slug: string | null) => void;
  reset: () => void;
}

const defaultParams: GenerationParams = {
  theme: '',
  pages: 8,
  ageGroup: '3-8',
  language: 'zh',
  style: '童话',
  tier: 'balanced',
};

export const useGeneratorStore = create<GeneratorState>((set) => ({
  step: 'theme',
  params: { ...defaultParams },
  status: null,
  error: null,
  isSubmitting: false,
  pollRetries: 0,
  cancelled: false,
  publishing: false,
  publishedSlug: null,

  setStep: (step) => set({ step }),
  setParams: (p) => set((s) => ({ params: { ...s.params, ...p } })),
  setStatus: (status) => set({ status }),
  setError: (error) => set({ error }),
  setSubmitting: (v) => set({ isSubmitting: v }),
  setPollRetries: (n) => set({ pollRetries: n }),
  setCancelled: (v) => set({ cancelled: v }),
  setPublishing: (v) => set({ publishing: v }),
  setPublishedSlug: (slug) => set({ publishedSlug: slug }),
  reset: () => set({
    step: 'theme',
    params: { ...defaultParams },
    status: null,
    error: null,
    isSubmitting: false,
    pollRetries: 0,
    cancelled: false,
    publishing: false,
    publishedSlug: null,
  }),
}));
